import { render, staticRenderFns } from "./MySubmit.vue?vue&type=template&id=d065f5e0&scoped=true"
import script from "./MySubmit.vue?vue&type=script&lang=js"
export * from "./MySubmit.vue?vue&type=script&lang=js"
import style0 from "./MySubmit.vue?vue&type=style&index=0&id=d065f5e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d065f5e0",
  null
  
)

export default component.exports